"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultInteractionSharedState = void 0;
const rc_js_util_1 = require("rc-js-util");
const i_hoverable_trait_1 = require("../../entities/traits/i-hoverable-trait");
const e_entity_update_flag_1 = require("../../update/e-entity-update-flag");
const on_hover_result_1 = require("./on-hover-result");
class DefaultInteractionSharedState {
    constructor(providers) {
        this.providers = providers;
        this.dragTargets = null;
        this.hoveredEntities = new Map();
    }
    clearAllHoveredEntities(chartEvent) {
        const updateFlag = emitHoverLeftEvents(chartEvent, rc_js_util_1._Map.valuesToArray(this.hoveredEntities));
        this.hoveredEntities.clear();
        if (updateFlag !== e_entity_update_flag_1.EEntityUpdateFlag.NoUpdateRequired) {
            this.providers.callbacks.onEntityRequiresUpdate(updateFlag);
        }
    }
    onHover(chartEvent) {
        const hoverTargets = this.providers.eventTargets.hoverTargetProvider.hitTestPlot(chartEvent);
        const hoverTargetsByEntity = rc_js_util_1._Array.index(hoverTargets, target => target.entity);
        const newlyHovered = rc_js_util_1._Map.setDifference(hoverTargetsByEntity, this.hoveredEntities);
        const noLongerHovered = rc_js_util_1._Map.setDifference(this.hoveredEntities, hoverTargetsByEntity);
        const stillHovered = rc_js_util_1._Map.intersect(hoverTargetsByEntity, this.hoveredEntities);
        const stillHoveredArray = rc_js_util_1._Map.valuesToArray(stillHovered);
        const newlyHoveredArray = rc_js_util_1._Map.valuesToArray(newlyHovered);
        const noLongerHoveredArray = rc_js_util_1._Map.valuesToArray(noLongerHovered);
        const segmentChanged = getSegmentChangedEntities(stillHovered, this.hoveredEntities);
        const segmentChangedArray = rc_js_util_1._Map.valuesToArray(segmentChanged);
        const unchanged = rc_js_util_1._Map.setDifference(stillHovered, segmentChanged);
        const unchangedArray = rc_js_util_1._Map.valuesToArray(unchanged);
        let updateFlag = emitHoverLeftEvents(chartEvent, noLongerHoveredArray);
        updateFlag |= emitSegmentChangeEvents(chartEvent, unchangedArray, i_hoverable_trait_1.EHoverState.Unchanged);
        updateFlag |= emitHoverEnterEvents(chartEvent, newlyHoveredArray);
        updateFlag |= emitSegmentChangeEvents(chartEvent, segmentChangedArray, i_hoverable_trait_1.EHoverState.SegmentChange);
        this.hoveredEntities = hoverTargetsByEntity;
        if (newlyHoveredArray.length > 0 || segmentChangedArray.length > 0 || noLongerHoveredArray.length > 0) {
            const result = new on_hover_result_1.OnHoverResult(newlyHoveredArray, stillHoveredArray, noLongerHoveredArray, unchangedArray);
            this.providers.callbacks.onHover(result, chartEvent);
        }
        if (updateFlag !== e_entity_update_flag_1.EEntityUpdateFlag.NoUpdateRequired) {
            this.providers.callbacks.onEntityRequiresUpdate(updateFlag);
        }
    }
    onClick(chartEvent) {
        const targets = this.providers.eventTargets.clickTargetProvider.hitTestPlot(chartEvent);
        const updateFlag = emitClickEvents(targets, chartEvent);
        this.providers.callbacks.onClick(targets, chartEvent);
        if (updateFlag !== e_entity_update_flag_1.EEntityUpdateFlag.NoUpdateRequired) {
            this.providers.callbacks.onEntityRequiresUpdate(updateFlag);
        }
    }
    onDblClick(chartEvent) {
        const targets = this.providers.eventTargets.clickTargetProvider.hitTestPlot(chartEvent);
        const updateFlag = emitDblClickEvents(targets, chartEvent);
        this.providers.callbacks.onDoubleClick(targets, chartEvent);
        if (updateFlag !== e_entity_update_flag_1.EEntityUpdateFlag.NoUpdateRequired) {
            this.providers.callbacks.onEntityRequiresUpdate(updateFlag);
        }
    }
}
exports.DefaultInteractionSharedState = DefaultInteractionSharedState;
function getSegmentChangedEntities(stillHovered, previouslyHovered) {
    const segmentChanged = new Map();
    // from those that were previously hovered, remove those where the segment hasn't changed
    stillHovered.forEach((target, key) => {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const newTarget = previouslyHovered.get(key);
        if (!rc_js_util_1._Set.isSetEqual(newTarget.segmentIds, target.segmentIds)) {
            segmentChanged.set(key, target);
        }
    });
    return segmentChanged;
}
function emitHoverLeftEvents(chartEvent, targets) {
    let updateFlag = e_entity_update_flag_1.EEntityUpdateFlag.NoUpdateRequired;
    for (let i = 0, iEnd = targets.length; i < iEnd; ++i) {
        const target = targets[i];
        if (target.entity.onHover != null) {
            updateFlag |= target.entity.onHover(i_hoverable_trait_1.EHoverState.Left, target.segmentIds, chartEvent);
        }
    }
    return updateFlag;
}
function emitHoverEnterEvents(chartEvent, targets) {
    let updateFlag = e_entity_update_flag_1.EEntityUpdateFlag.NoUpdateRequired;
    for (let i = 0, iEnd = targets.length; i < iEnd; ++i) {
        const target = targets[i];
        if (target.entity.onHover != null) {
            updateFlag |= target.entity.onHover(i_hoverable_trait_1.EHoverState.Entered, target.segmentIds, chartEvent);
        }
    }
    return updateFlag;
}
function emitSegmentChangeEvents(chartEvent, targets, state) {
    let updateFlag = e_entity_update_flag_1.EEntityUpdateFlag.NoUpdateRequired;
    for (let i = 0, iEnd = targets.length; i < iEnd; ++i) {
        const target = targets[i];
        if (target.entity.onHover != null) {
            updateFlag |= target.entity.onHover(state, target.segmentIds, chartEvent);
        }
    }
    if (state === i_hoverable_trait_1.EHoverState.Unchanged) {
        return e_entity_update_flag_1.EEntityUpdateFlag.NoUpdateRequired;
    }
    else {
        return updateFlag;
    }
}
function emitClickEvents(targets, chartEvent) {
    let updateFlag = e_entity_update_flag_1.EEntityUpdateFlag.NoUpdateRequired;
    for (let i = 0, iEnd = targets.length; i < iEnd; ++i) {
        const target = targets[i];
        if (target.entity.onClick != null) {
            updateFlag |= target.entity.onClick(chartEvent, target.segmentIds);
        }
    }
    return updateFlag;
}
function emitDblClickEvents(targets, chartEvent) {
    let updateFlag = e_entity_update_flag_1.EEntityUpdateFlag.NoUpdateRequired;
    for (let i = 0, iEnd = targets.length; i < iEnd; ++i) {
        const target = targets[i];
        if (target.entity.onDblClick != null) {
            updateFlag |= target.entity.onDblClick(chartEvent, target.segmentIds);
        }
    }
    return updateFlag;
}
//# sourceMappingURL=default-interaction-shared-state.js.map